import styled from 'styled-components';

export const NavbarWrap = styled.ul `
    display: flex;
`; 